import React, { useState, useEffect } from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import FileUploader from 'devextreme-react/file-uploader';
import * as Store from '@apply/store';
import GoogleDocIFrameViewer from '../viewers/GoogleDocIFrameViewer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

export interface FloodReportEsignModalProps {
    isOpen: boolean;
    onCloseCallback?: (tempfileName: string) => void;
    notice?: Store.UserStore.Types.UserNotice;
}

export const FloodReportEsignModal: React.FC<FloodReportEsignModalProps> = ({ isOpen, onCloseCallback, notice }) => {
    const [fileToUpload, set_fileToUpload] = useState(null);

    const maxFileSize = 1024 * 1024 * 35;
    const [canContinue, set_canContinue] = useState(false);

    const handleClose = () => {
        onCloseCallback(null);
    };

    const styles: Record<string, React.CSSProperties> = {
        button: {
            width: 175,
        },
        noPadding: {
            padding: 0,
        },
    };

    const onFilesChanged = (fileArray) => {
        const files = fileArray.filter((file) => file.size <= maxFileSize);
        if (files && files.length > 0) {
            set_canContinue(true);
        } else {
            set_canContinue(false);
        }
        set_fileToUpload(files[0]);
    };

    const submitFile = () => {
        onCloseCallback(fileToUpload);
    };

    if (!notice) {
        return null;
    }

    return (
        <div>
            <Dialog
                open={isOpen}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                maxWidth='md'
            >
                <DialogContent>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            role='dialog'
                            style={{ width: '51vw' }}
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <div
                                    className='page-header'
                                    role='banner'
                                >
                                    <h1>{notice.signedFile ? 'Signed Flood Notice' : 'Sign Flood Notice'}</h1>
                                    <button
                                        type='button'
                                        className='close'
                                        data-dismiss='modal'
                                        aria-label='Close'
                                        onClick={handleClose}
                                    >
                                        <span aria-hidden='true'>&times;</span>
                                    </button>
                                </div>
                                {notice.eSignDate && notice.signedFile && notice.signedFile.url && (
                                    <GoogleDocIFrameViewer
                                        title='noticeIFrame'
                                        url={`${encodeURIComponent(notice.signedFile.url)}`}
                                        height='700px'
                                        width='100%'
                                    />
                                )}
                                <div className='modal-content modal-content--esign'>
                                    <div className='modal-body'>
                                        <div
                                            className='standard-form'
                                            style={styles.noPadding}
                                        >
                                            {!(notice.eSignDate && notice.signedFile) && (
                                                <ol>
                                                    <li>
                                                        Please click{' '}
                                                        <a
                                                            href={notice.noticeFile.url}
                                                            target='_blank'
                                                            rel='noreferrer'
                                                        >
                                                            here
                                                        </a>{' '}
                                                        to download the flood report, or click on the download icon{' '}
                                                        <a
                                                            href={notice.noticeFile.url}
                                                            target='_blank'
                                                            rel='noreferrer'
                                                        >
                                                            <FontAwesomeIcon
                                                                icon={faDownload}
                                                                aria-hidden='true'
                                                            />
                                                        </a>
                                                    </li>
                                                    <li>
                                                        After download please print the document, sign and the scan. OR use a tool
                                                        such as Adobe reader to sign the document electronically.
                                                    </li>
                                                    <li>
                                                        Click on the 'Select File' button below and select the signed flood
                                                        report.
                                                        <div
                                                            style={{
                                                                padding: '10px 10px',
                                                            }}
                                                        >
                                                            <div
                                                                id='drop_zone'
                                                                style={{
                                                                    width: '100%',
                                                                    backgroundColor: 'silver',
                                                                    padding: '10px',
                                                                }}
                                                            >
                                                                <FileUploader
                                                                    selectButtonText='Select File'
                                                                    uploadMode='useForm'
                                                                    maxFileSize={maxFileSize}
                                                                    invalidFileExtensionMessage='Invalid File Type. File will be ignored'
                                                                    invalidMaxFileSizeMessage='File too large. File will be ignored'
                                                                    multiple={false}
                                                                    allowedFileExtensions={['.pdf', '.png', '.jpg']}
                                                                    allowCanceling={true}
                                                                    labelText='or Drag & Drop the file here'
                                                                    onValueChange={onFilesChanged}
                                                                />
                                                            </div>
                                                        </div>
                                                        button
                                                    </li>
                                                    <li>Click on the Submit button to upload the signed flood report.</li>
                                                </ol>
                                            )}
                                            <div></div>
                                            <div className='modal-content-actions'>
                                                {!(notice.eSignDate && notice.signedFile) && (
                                                    <button
                                                        type='button'
                                                        data-testid='accept-button'
                                                        className='button primary'
                                                        style={styles.button}
                                                        onClick={submitFile}
                                                        disabled={!canContinue}
                                                    >
                                                        Submit
                                                    </button>
                                                )}
                                                <button
                                                    type='button'
                                                    data-testid='do-not-accept-button'
                                                    className='button'
                                                    style={styles.button}
                                                    onClick={handleClose}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
        </div>
    );
};
